window.translations = {
  "domain": "app",
  "locale_data": {
    "app": {
      "": {
        "Project-Id-Version": "app 1.0.0",
        "Report-Msgid-Bugs-To": "",
        "PO-Revision-Date": "2022-05-05 21:30+0800",
        "Last-Translator": "xfyuan <xfyuan@gitlab.cn>",
        "Language-Team": "Chinese",
        "Language": "zh_CN",
        "MIME-Version": "1.0",
        "Content-Type": "text/plain; charset=UTF-8",
        "Content-Transfer-Encoding": "8bit",
        "Plural-Forms": "nplurals=; plural=;",
        "lang": "zh_CN",
        "domain": "app",
        "plural_forms": "nplurals=; plural=;"
      },
      "%{contactName} (%{workEmail}) is not a billing account manager. Select a new contact.": [
        "%{contactName}（%{workEmail}）不是计费账户管理员。请选择新的联系人。"
      ],
      "%{count} credits remaining": [
        "剩余 %{count} Credit"
      ],
      "%{count} pool credits remaining": [
        "剩余 %{count} 预购额度 Credit"
      ],
      "%{field} must be %{maxChar} characters or less.": [
        "%{field} 不得超过 %{maxChar} 个字符。"
      ],
      "%{percentage}% utilized": [
        "已使用 %{percentage}%"
      ],
      "%{quantityLabel} cannot exceed %{maxQuantity}": [
        "%{quantityLabel} 不能超过 %{maxQuantity}"
      ],
      "%{quantityLabel} must be at least %{minQuantity}": [
        "%{quantityLabel} 至少为 %{minQuantity}"
      ],
      "%{value} is not accessible": [
        "%{value} 不可访问"
      ],
      "(optional)": [
        "（可选）"
      ],
      "(required)": [
        "（必填）"
      ],
      "1000 CI minutes pack": [
        "CI 1000 分钟包"
      ],
      "1000-unit compute pack": [
        "1000 分钟包"
      ],
      "10GB storage pack": [
        "10GB 存储包"
      ],
      "30 million token package": [
        "30 million token 包"
      ],
      "600 million token package": [
        "6 亿 token 包"
      ],
      "Ability to renew will be available starting": [
        "续订开启时间为"
      ],
      "Ability to renew will be available starting ": [
        "续订开启时间为"
      ],
      "Account ID:": [
        "账户 ID："
      ],
      "Account cannot be deleted": [
        "账户无法删除"
      ],
      "Account not found. If the problem persists, %{supportLinkStart}contact support%{supportLinkEnd}.": [
        "未找到账户。如果问题持续存在，请%{supportLinkStart}联系客服%{supportLinkEnd}。"
      ],
      "Actions": [
        "操作"
      ],
      "Active users": [
        "活跃用户"
      ],
      "Add a new subscription?": [
        "添加新订阅?"
      ],
      "Add a promo code": [
        "请输入优惠券"
      ],
      "Add additional seats": [
        "添加额外席位"
      ],
      "Add more seats": [
        "添加更多席位"
      ],
      "Add new subscription": [
        "添加新订阅"
      ],
      "Add seats": [
        "添加更多席位"
      ],
      "Additional seats have the same term as your main subscription, and the price prorated accordingly.": [
        "您增加的席位与您的主订阅具有相同的期限，并且价格按相应比例分配。"
      ],
      "Address 1": [
        "地址 1"
      ],
      "Address 2": [
        "地址 2"
      ],
      "Address line 2": [
        "地址行 2"
      ],
      "Already have a login and password?": [
        "已有登录名和密码？"
      ],
      "Amount": [
        "总计"
      ],
      "An error occurred, please try again later.": [
        "出现错误，请稍后再试。"
      ],
      "An unexpected error occurred. If the problem persists,": [
        "出现错误，如果问题仍然存在，"
      ],
      "Annual seat review": [
        "年度席位审查"
      ],
      "Apply": [
        "使用"
      ],
      "Apply promo code successfully": [
        "优惠券应用成功"
      ],
      "Are you sure you want to delete this record?": [
        "确定要删除此记录吗？"
      ],
      "Awaiting user registration": [
        "等待用户注册"
      ],
      "Before you can renew your subscription, you'll need to fill out the": [
        "在您续订之前，您需要填写"
      ],
      "Billed annually": [
        "按年付费"
      ],
      "Billing account access is required for the subscription linked to this namespace": [
        "需要计费账户权限才能访问此命名空间关联的订阅"
      ],
      "Billing account manager": [
        "计费账户管理员"
      ],
      "Billing account manager removed.": [
        "计费账户管理员已移除。"
      ],
      "Billing account managers": [
        "计费账户管理员"
      ],
      "Billing account managers can access this billing account and be selected as the subscription contact.": [
        "计费账户管理员可以访问此计费账户，并可被选为订阅联系人。"
      ],
      "Billing account managers can view and edit subscriptions, payment methods, and account settings, as well as pay and download invoices.": [
        "计费账户管理员可以查看和编辑订阅、支付方式、账户设置，以及支付和下载发票。"
      ],
      "Billing account settings": [
        "计费账户设置"
      ],
      "Billing contact": [
        "账单联系人"
      ],
      "Billing contact is the same as subscription contact": [
        "账单联系人与订阅联系人相同"
      ],
      "Billing information": [
        "账单信息"
      ],
      "Buy": [
        "购买"
      ],
      "Buy %{product}": [
        "购买 %{product}"
      ],
      "Buy CodeRider Team SaaS": [
        "购买 CodeRider SaaS 团队版"
      ],
      "Buy GitLab credits": [
        "购买 GitLab Credits"
      ],
      "Buy coderider token package": [
        "购买 CodeRider Token 包"
      ],
      "Buy compute minutes": [
        "购买计算分钟数"
      ],
      "Buy more compute": [
        "购买更多计算分钟数"
      ],
      "Buy more compute minutes": [
        "购买更多 CI 分钟"
      ],
      "Buy more storage": [
        "购买更多存储"
      ],
      "Buy new subscription": [
        "购买新订阅"
      ],
      "Buy now": [
        "立即购买"
      ],
      "Buy storage": [
        "购买存储"
      ],
      "Buy subscription": [
        "购买订阅"
      ],
      "CI minutes (1000 min/pack)": [
        "CI 分钟（1000 分钟/包）"
      ],
      "Cancel": [
        "取消"
      ],
      "Cancels": [
        "取消"
      ],
      "Cannot remove this member: removing it would make billing account ownership conflict with another billing account that has resources.": [
        "无法移除此成员：移除后计费账户归属会与其他已有资源的计费账户冲突。"
      ],
      "Change my password": [
        "更改我的密码"
      ],
      "Change the GitLab.com account that is linked to your Customers Portal profile.": [
        "更改与您的极狐订单管理中心个人资料关联的极狐GitLab 账户。"
      ],
      "Change the subscription contact before removing this manager.": [
        "请先更改订阅联系人，再移除此管理员。"
      ],
      "City": [
        "城市"
      ],
      "Click and copy to the clipboard.": [
        "点击复制"
      ],
      "CodeRider Team SaaS": [
        "CodeRider SaaS 团队版"
      ],
      "CodeRider Token Package": [
        "CodeRider Token 包"
      ],
      "Collapse": [
        "折叠"
      ],
      "Company details": [
        "公司详情"
      ],
      "Company information": [
        "公司信息"
      ],
      "Company name": [
        "公司名称"
      ],
      "Company name is required.": [
        "公司名称不能为空。"
      ],
      "Company or organization name.": [
        "公司或组织名称。"
      ],
      "Company, organization, or team name": [
        "公司、组织或团队名称"
      ],
      "Compute packs": [
        "计算分钟包"
      ],
      "Compute packs are only used after you've used your subscription's monthly quota. The additional compute minutes will roll over month to month and are valid for one year.": [
        "计算分钟包仅在您用完订阅的每月配额后才能使用。 额外的分钟数将按月滚动，有效期为一年。"
      ],
      "Confirm Password": [
        "确认密码"
      ],
      "Confirm new password": [
        "确认密码"
      ],
      "Confirm purchase": [
        "确认购买"
      ],
      "Contact Us": [
        "联系我们"
      ],
      "Contact us": [
        "联系我们"
      ],
      "Continue": [
        "继续"
      ],
      "Continue with your JiHulab.com account": [
        "极狐GitLab 账户登录"
      ],
      "Could not fetch namespaces from GitLab.com. Please try again": [
        "无法从 极狐GitLab 上获取命名空间，请稍后再试。"
      ],
      "Could not fetch namespaces from JiHuLab.com. Please try again": [
        "无法从 极狐GitLab 上获取命名空间，请稍后再试。"
      ],
      "Could not get the data properly": [
        "无法正确获取数据"
      ],
      "Could not update billing account information": [
        "无法更新计费账户信息"
      ],
      "Country": [
        "国家/地区"
      ],
      "Coupon code": [
        "优惠券码"
      ],
      "Credit for the remainder of your subscription term with %{userCount} user": [
        "您需要为 %{userCount} 个用户支付订阅期限剩余的 %{percent}%"
      ],
      "Credit usage": [
        "Credit 用量"
      ],
      "Credits are valid until the current subscription end date of %{date}, for a total of %{monthCount} months. Credits reset each month.": [
        "Credit 有效期即为当前订阅结束日期 %{date}，共计 %{monthCount} 个月。Credit 会在每个月重置。"
      ],
      "Credits that reset each month.": [
        "Credit 在每个月重置"
      ],
      "Credits used after any included user credits and monthly commitment pool have been exhausted. Learn about %{linkStart}GitLab Credit pricing%{linkEnd}.": [
        "在内置额度和月度额度池用尽后使用的 Credit。了解 %{linkStart}GitLab Credits 定价%{linkEnd}。"
      ],
      "Current": [
        "当前"
      ],
      "Current Password": [
        "当前密码"
      ],
      "Current seats": [
        "当前席位"
      ],
      "Custom contact": [
        "自定义联系人"
      ],
      "Custom contact cannot be a billing account manager. To set this user as a billing contact, select them from the User dropdown.": [
        "自定义联系人不能是计费账户管理员。要将此用户设为账单联系人，请从用户下拉菜单中选择。"
      ],
      "Customer information": [
        "客户信息"
      ],
      "Customers Portal": [
        "极狐订单管理中心"
      ],
      "Customers Portal is a standalone site for managing payment and license information": [
        "极狐订单管理中心是管理支付和许可证信息的独立站点"
      ],
      "Documentation": [
        "文档中心"
      ],
      "Edit": [
        "编辑"
      ],
      "Edit in settings": [
        "在设置中编辑"
      ],
      "Edit my account": [
        "编辑我的账户"
      ],
      "Email": [
        "邮箱"
      ],
      "Email address": [
        "邮箱地址"
      ],
      "Enabled": [
        "已启用"
      ],
      "End date": [
        "结束时间"
      ],
      "Enter a custom contact": [
        "输入自定义联系人"
      ],
      "Enter email address.": [
        "请输入邮箱地址。"
      ],
      "Enter the coupon code provided in your email.": [
        "请输入电子邮件中的优惠券码"
      ],
      "Estimated taxes": [
        "增值税"
      ],
      "Expand": [
        "展开"
      ],
      "Expired": [
        "过期"
      ],
      "Expires": [
        "有效期"
      ],
      "Expires on": [
        "过期时间"
      ],
      "Export usage data": [
        "导出用量数据"
      ],
      "Failed to fetch dashboard data": [
        "获取仪表盘数据失败"
      ],
      "First name": [
        "名"
      ],
      "Forgot your password?": [
        "忘记密码？"
      ],
      "Frequently asked questions": [
        "常见问题"
      ],
      "GitLab Credits": [
        "GitLab Credits"
      ],
      "GitLab Credits - Monthly Committed Pool": [
        "GitLab Credits - 月度额度"
      ],
      "GitLab Credits - Monthly Waiver": [
        "GitLab Credits - 预购额度"
      ],
      "GitLab Credits - Monthly committed pool": [
        "GitLab Credits - 月度预购额度"
      ],
      "GitLab Credits - On Demand": [
        "GitLab Credits - 按需额度"
      ],
      "GitLab Credits - Temporary evaluation credits": [
        "GitLab Credits - 临时评估 Credit"
      ],
      "GitLab Credits dashboard": [
        "GitLab Credits 使用面板"
      ],
      "GitLab Enterprise Edition": [
        "极狐GitLab 企业版"
      ],
      "GitLab Subscription [Management]": [
        "极狐GitLab 订阅[管理]"
      ],
      "GitLab Ultimate": [
        "旗舰版"
      ],
      "GitLab compute": [
        "计算分钟数"
      ],
      "GitLab compute is a one-time purchase that does not renew.": [
        "计算分钟数是一次性购买"
      ],
      "GitLab credits": [
        "GitLab Credits"
      ],
      "GitLab group:": [
        "极狐GitLab 群组"
      ],
      "GitLab storage": [
        "存储"
      ],
      "GitLab subscription": [
        "极狐GitLab 订阅"
      ],
      "GitLab.com %{comPlanName} plan": [
        "JiHuLab.com %{comPlanName} 计划"
      ],
      "Group": [
        "群组"
      ],
      "Groups": [
        "群组"
      ],
      "Hide details": [
        "隐藏"
      ],
      "Hide sidebar": [
        "隐藏侧边栏"
      ],
      "Host your own instance on-premises or in the cloud": [
        "在本地或云上托管您的实例"
      ],
      "How does billing work ?": [
        "收费详情"
      ],
      "How pricing works.": [
        "查看详情"
      ],
      "I accept the": [
        "我接受"
      ],
      "Increase monthly commitment": [
        "增加月度额度"
      ],
      "Increase monthly credit commitment": [
        "增加月度额度"
      ],
      "Increase your commitment to unlock deeper discounts. Pool GitLab Credits across your namespace for flexibility and predictable monthly costs. %{linkStart}GitLab Credit pricing%{linkEnd}.": [
        "增加月度额度以解锁更优惠折扣。在命名空间内共享 GitLab Credits，获得灵活性和可预测的月度成本。%{linkStart}GitLab Credits 定价%{linkEnd}。"
      ],
      "Information about your company/organization.": [
        "您的公司或组织信息。"
      ],
      "Invitation expires on %{date} at %{time}.": [
        "邀请过期时间：%{date} %{time}。"
      ],
      "Invitation sent.": [
        "邀请已发送。"
      ],
      "Invite": [
        "邀请"
      ],
      "Invite a user to manage the %{companyName} billing account. Billing account managers can view and edit subscriptions, payment methods, and account settings, as well as pay and download invoices.": [
        "邀请用户管理 %{companyName} 计费账户。计费账户管理员可以查看和编辑订阅、支付方式、账户设置，以及支付和下载发票。"
      ],
      "Invite additional users to the Customers Portal to manage your billing account.": [
        "邀请其他用户到极狐订单管理中心管理您的计费账户。"
      ],
      "Invite billing account manager": [
        "邀请计费账户管理员"
      ],
      "Invoices": [
        "发票"
      ],
      "JH CustomerDot ADMIN": [
        "极狐CustomerDot后台"
      ],
      "JiHu GitLab Credits Monthly Committed Pool Exhausted": [
        "GitLab Credits 月度额度已用尽"
      ],
      "JiHu GitLab Credits Monthly Committed Pool at %{percentage}": [
        "GitLab Credits 月度额度已使用 %{percentage}"
      ],
      "JiHu GitLab Credits Monthly Usage Digest": [
        "GitLab Credits 月度用量摘要"
      ],
      "JiHu GitLab Credits Subscription Cap Reached: %{subscription_name}": [
        "GitLab Credits 订阅上限已达：%{subscription_name}"
      ],
      "JiHuLab.com": [
        "极狐GitLab"
      ],
      "Last name": [
        "姓"
      ],
      "Last transaction received at:": [
        "最后一次交易接收时间："
      ],
      "Learn more about %{helpLinkStart}GitLab Credit pricing%{helpLinkEnd}.": [
        "了解 %{helpLinkStart}GitLab Credits 定价%{helpLinkEnd}。"
      ],
      "Licensing FAQ": [
        "许可常见问题"
      ],
      "Limit on-demand usage for this subscription.": [
        "限制此订阅的按需用量。"
      ],
      "List of subscriptions": [
        "订阅列表"
      ],
      "Manage existing": [
        "管理现有订阅"
      ],
      "Manage purchases": [
        "购买管理"
      ],
      "Minimum length is 8 characters.": [
        "密码长度最少为8位"
      ],
      "Monthly Waiver credits remaining": [
        "预购额度剩余"
      ],
      "Monthly Waiver credits used this period": [
        "本周期预购额度已使用"
      ],
      "Monthly commitments offer significant discounts off list price. Share GitLab Credits across your namespace for flexibility and predictable monthly costs. Learn more about %{linkStart}GitLab Credit pricing%{linkEnd}.": [
        "月度额度提供显著折扣。在命名空间内共享 GitLab Credits，获得灵活性和可预测的月度成本。了解更多 %{linkStart}GitLab Credits 定价%{linkEnd}。"
      ],
      "Monthly credits": [
        "月度额度"
      ],
      "Multiple names found for %{workEmail}. Notify %{workEmail} to update their personal profile.": [
        "发现 %{workEmail} 有多个姓名。请通知 %{workEmail} 更新其个人资料。"
      ],
      "Multiple names found for %{workEmail}. Update your name in your %{profileLinkStart}personal profile%{profileLinkEnd}.": [
        "发现 %{workEmail} 有多个姓名。请在%{profileLinkStart}个人资料%{profileLinkEnd}中更新您的姓名。"
      ],
      "My billing account": [
        "我的账单"
      ],
      "My profile": [
        "我的账号"
      ],
      "Name": [
        "姓名"
      ],
      "Need to register for a Customers Portal account?": [
        "需要注册极狐订单管理中心账号?"
      ],
      "New": [
        "新建"
      ],
      "New Password": [
        "新密码"
      ],
      "New password": [
        "新密码"
      ],
      "New seats quantity": [
        "新席位数量"
      ],
      "New subscription for": [
        "新订阅"
      ],
      "New subscription term for": [
        "新订阅时间"
      ],
      "Not enabled": [
        "未启用"
      ],
      "Not set": [
        "未设置"
      ],
      "On-Demand billing is active": [
        "按需计费已启用"
      ],
      "On-Demand billing is not active": [
        "按需计费未启用"
      ],
      "On-demand billing is now available for your subscription.": [
        "按需计费现在可用于您的订阅。"
      ],
      "On-demand credit cap": [
        "按需额度上限"
      ],
      "On-demand credit cap updated.": [
        "按需额度上限已更新。"
      ],
      "Order already have promo code": [
        "订单中已存在优惠券"
      ],
      "Order summary": [
        "订单详情"
      ],
      "Order total": [
        "总价"
      ],
      "Payment methods": [
        "支付方式"
      ],
      "Please enter a valid quantity": [
        "请输入合法数量"
      ],
      "Please select a group namespace instead of a user namespace.": [
        "请选择群组命名空间，而不是用户命名空间。"
      ],
      "Please select a valid namespace.": [
        "请选择有效命名空间"
      ],
      "Please sign in to complete your purchase": [
        "请登录以完成购买"
      ],
      "Postal code": [
        "邮编"
      ],
      "Premium": [
        "专业版"
      ],
      "Price": [
        "价格"
      ],
      "Price for the remainder of your subscription term": [
        "您需要为订阅期限剩余的支付"
      ],
      "Price per unit": [
        "单位价格"
      ],
      "Price per user": [
        "单人价格"
      ],
      "Price per user per month": [
        "用户/月"
      ],
      "Privacy Statement": [
        "隐私协议"
      ],
      "Product": [
        "购买产品"
      ],
      "Profile settings": [
        "账号设置"
      ],
      "Promo code cannot remove": [
        "优惠券不能被移除"
      ],
      "Promo code expired": [
        "此优惠券不存在或已失效，请检查后再次输入。"
      ],
      "Promo code inactive": [
        "优惠券未启用"
      ],
      "Promo code limit max usage": [
        "该优惠券使用次数已超上限。"
      ],
      "Promo code not eligible": [
        "当前订单不满足优惠券适用范围。"
      ],
      "Promo code not found": [
        "此优惠券不存在或已失效，请检查后再次输入。"
      ],
      "Promo code removed": [
        "优惠券移除成功。"
      ],
      "Promo code used by other invoice": [
        "此优惠券已被其他订单锁定或使用。"
      ],
      "Promot code": [
        "优惠券"
      ],
      "Purchase monthly commitment": [
        "购买月度额度"
      ],
      "Purchase seats": [
        "购买席位"
      ],
      "Purchase summary": [
        "购买汇总"
      ],
      "Quantity": [
        "数量"
      ],
      "Quantity must be greater than or equal to namespace billable members count (%{members_count})": [
        "购买席位数必须大于或等于命名空间可计费成员数（%{members_count}）。"
      ],
      "Receipt|cancelled": [
        "已撤销"
      ],
      "Receipt|company": [
        "企业"
      ],
      "Receipt|completed": [
        "已开票"
      ],
      "Receipt|draft": [
        "申请开票"
      ],
      "Receipt|electronic": [
        "电子发票"
      ],
      "Receipt|exception": [
        "发票异常"
      ],
      "Receipt|normal_tax": [
        "增值税普通发票"
      ],
      "Receipt|paper": [
        "纸质发票"
      ],
      "Receipt|person": [
        "个人发票"
      ],
      "Receipt|process": [
        "开票中"
      ],
      "Receipt|special_tax": [
        "增值税专项发票"
      ],
      "Reload the page to try again.": [
        "请重新加载页面重试。"
      ],
      "Remove": [
        "移除"
      ],
      "Remove billing account manager?": [
        "移除计费账户管理员？"
      ],
      "Remove promo code": [
        "移除优惠券"
      ],
      "Renew subscription": [
        "续订"
      ],
      "Renews": [
        "续订"
      ],
      "Renews on": [
        "续订"
      ],
      "Resend confirmation instructions": [
        "重新发送确认"
      ],
      "Reset Password": [
        "重置密码"
      ],
      "Review and modify your subscription details. Changes will take effect only after you complete the renewal process.": [
        "查看并修改你的订阅详情。变更仅在你完成续费流程后生效。"
      ],
      "Revoke invitation for billing account manager?": [
        "撤销计费账户管理员邀请？"
      ],
      "Rules and actions cannot be empty": [
        "策略规则与折扣方式不能为空"
      ],
      "SaaS - Premium (formerly Silver) - 1 Year": [
        "SaaS 专业版一年"
      ],
      "SaaS - Premium - 1 Year": [
        "SaaS 专业版一年"
      ],
      "SaaS - Team (New Plan) - 1 Year": [
        "SaaS 团队版一年"
      ],
      "SaaS - Team - 1 Year": [
        "SaaS 团队版 一年"
      ],
      "SaaS - Ultimate (formerly Gold) - 1 Year": [
        "SaaS 旗舰版一年"
      ],
      "SaaS - Ultimate - 1 Year": [
        "SaaS 旗舰版一年"
      ],
      "SaaS offering hosted by GitLab": [
        "极狐GitLab 托管的 SaaS 产品"
      ],
      "Saas - Ultimate Trial": [
        "Saas 旗舰试用版"
      ],
      "Sales tax": [
        "税"
      ],
      "Save Changes": [
        "保存更改"
      ],
      "Save changes": [
        "保存更改"
      ],
      "Save on GitLab Credits with monthly commitment": [
        "通过月度额度节省 GitLab Credits"
      ],
      "Seats": [
        "席位"
      ],
      "Seats purchased": [
        "已购席位"
      ],
      "Select billing account manager": [
        "选择计费账户管理员"
      ],
      "Select country": [
        "选择国家/地区"
      ],
      "Select group": [
        "选择群组"
      ],
      "Select more seats": [
        "选择更多席位"
      ],
      "Select plan": [
        "选择计划"
      ],
      "Select state": [
        "选择州/省"
      ],
      "Select your plan": [
        "选择您的计划"
      ],
      "Self-Managed - GitLab Duo Core - 1 Year": [
        "Self-Managed Duo Core 一年"
      ],
      "Self-Managed - GitLab Duo Enterprise - 1 Year": [
        "Self-Managed Duo 企业版 一年"
      ],
      "Self-Managed - GitLab Duo Pro - 1 Year": [
        "Self-Managed Duo Pro 一年"
      ],
      "Self-Managed - GitLab Duo Self-Hosted DAP - 1 Year": [
        "Self-Managed Duo Self-Hosted Dap 一年 "
      ],
      "Self-Managed - Premium - 1 Year": [
        "Self-Managed-专业版一年"
      ],
      "Self-Managed - Ultimate - 1 Year": [
        "Self-Managed-旗舰版一年"
      ],
      "Set an overall on-demand credit cap for this subscription.": [
        "为此订阅设置整体的按需额度上限。"
      ],
      "Set on-demand credit cap": [
        "设置按需额度上限"
      ],
      "Show": [
        "查看"
      ],
      "Show details": [
        "展开"
      ],
      "Sign in": [
        "登录"
      ],
      "Sign in or register with a GitLab.com account": [
        "通过极狐GitLab账号登录"
      ],
      "Sign in with Jihulab.com account": [
        "极狐GitLab账号登录"
      ],
      "Sign out": [
        "退出登录"
      ],
      "Something went wrong": [
        "出现错误，请稍后再试。"
      ],
      "Something went wrong. Please try again.": [
        "出现错误，请稍后再试。"
      ],
      "Spend controls": [
        "消费控制"
      ],
      "Start date": [
        "开始日期"
      ],
      "Start renewal": [
        "开始续订"
      ],
      "Starter - 1 Year": [
        "基础扩展版 1 年"
      ],
      "Starts": [
        "开始"
      ],
      "State": [
        "州/省"
      ],
      "State / Province": [
        "州/省份"
      ],
      "Statement": [
        "账单"
      ],
      "Storage (10GB/pack)": [
        "存储（10GB/包）"
      ],
      "Storage packs": [
        "存储包"
      ],
      "Submit feedback": [
        "提交反馈"
      ],
      "Subscription and billing contact": [
        "订阅和账单联系人"
      ],
      "Subscription contact": [
        "订阅联系人"
      ],
      "Subscription contact can't be removed": [
        "订阅联系人无法移除"
      ],
      "Subscription details": [
        "订阅详情"
      ],
      "Subscription exceeds the team plan seats limit": [
        "您最多只能为团队版购买10个席位。要继续购买，请升级到更高版本。"
      ],
      "Subscription params were not valid": [
        "订阅购买参数有误"
      ],
      "Subscriptions & purchases": [
        "订阅和购买"
      ],
      "Subscriptions and add-ons that you purchase will appear here.": [
        "您的订阅和增购会出现在这里"
      ],
      "Subscriptions and purchases": [
        "订阅和购买"
      ],
      "Subtotal": [
        "小计"
      ],
      "Subtotal for the new subscription": [
        "新订阅小计"
      ],
      "Suspend the promotion before editing it": [
        "请先暂停该策略再编辑"
      ],
      "Tax ID": [
        "税务识别号"
      ],
      "Team": [
        "团队版"
      ],
      "Terms of Service.": [
        "服务条款"
      ],
      "Text successfully copied to the clipboard.": [
        "复制成功"
      ],
      "Thank you!": [
        "谢谢"
      ],
      "The Customers Portal is a secure site for managing GitLab subscriptions, billing contacts, payments, and license details, accessed with your GitLab.com account.": [
        "极狐订单管理中心是一个安全的站点，用于管理极狐 GitLab 订阅、账单联系人、付款和许可证详情，您可以使用极狐 GitLab 账号访问。"
      ],
      "The Customers Portal is a standalone site for managing payment and license information": [
        "极狐订单管理中心是管理支付和许可证信息的独立站点"
      ],
      "The account cannot be deleted since the member is a bill to / sold to contact on the account.": [
        "该账户无法删除，因为该成员是账户的账单/订阅联系人。"
      ],
      "The length of promotion code should be between 6 and 15 characters.": [
        "优惠券码长度为 6-15 位"
      ],
      "The price per credit for monthly credits is based on pricing tiers. You are billed for usage beyond monthly credits.": [
        "月度额度的单额度价格基于定价阶梯。超出月度额度的使用量将另行计费。"
      ],
      "These are credits consumed beyond your users included credits, charged at standard on-demand rates.": [
        "这些是超出内置额度的用量，按标准按需费率计费。"
      ],
      "This is your Customers Portal profile email address and is linked to your GitLab.com account.": [
        "这是您极狐订单管理中心的邮箱地址，已关联到您的极狐GitLab 账户。"
      ],
      "This is your Customers Portal profile email address.": [
        "这是您极狐订单管理中心的邮箱地址。"
      ],
      "This number must be %{owedSeats} (your owed seats) or more.": [
        "你最少拥有%{owedSeats} 坐席数量"
      ],
      "This purchase is for:": [
        "购买用于"
      ],
      "This receipt have invalid invoices": [
        "发票中含有不合法的订单"
      ],
      "This receipt have no invoices": [
        "发票中不含订单"
      ],
      "To reactivate your subscription, renew by %{renewalExpirationDate}.": [
        "为了继续使用您的订阅，续订将在 %{renewalExpirationDate} 开启"
      ],
      "Toggle details": [
        "切换详情"
      ],
      "Total": [
        "总计"
      ],
      "Total Amount": [
        "总计"
      ],
      "Total on-demand usage allowed for this subscription during the current billing period.": [
        "当前计费周期内此订阅允许的总按需用量。"
      ],
      "Ultimate": [
        "旗舰版"
      ],
      "Unknown error occurred, this has been logged in our service. Open a Support ticket if the problem persists.": [
        "发生未知错误，已记录在我们的服务中。如果问题仍然存在，请尝试提交工单。"
      ],
      "Update information about your company/organization and its primary contacts.": [
        "更新您的公司或组织及其主要联系人的信息。"
      ],
      "Update your company information.": [
        "更新您的公司信息。"
      ],
      "Update your name and billing address": [
        "更新您的姓名和账单地址"
      ],
      "Upgrade details": [
        "升级详情"
      ],
      "Upgrade plan": [
        "升级计划"
      ],
      "Upgrade subscription": [
        "升级订阅"
      ],
      "Upgrade to": [
        "升级"
      ],
      "Upgraded": [
        "升级"
      ],
      "Usage overview": [
        "用量概览"
      ],
      "Usage period": [
        "使用周期"
      ],
      "Usage trends": [
        "用量趋势"
      ],
      "Used this billing period, expires in %d day": [
        "本计费周期已使用，%d 天后过期",
        "本计费周期已使用，%d 天后过期"
      ],
      "Used this month": [
        "本月已使用"
      ],
      "Used this usage period": [
        "本使用周期已使用"
      ],
      "Used this usage period, resets in %d day": [
        "本使用周期已使用，%d 天后重置",
        "本使用周期已使用，%d 天后重置"
      ],
      "User": [
        "用户"
      ],
      "VAT, GST, DST, or other tax identification number.": [
        "VAT、GST、DST 或其他税务识别号。"
      ],
      "View invoices": [
        "查看发票"
      ],
      "We can't transfer plan subscriptions to a group which already has a purchased plan.": [
        "无法将计划订阅转移到已购买计划的群组。"
      ],
      "We use this email for notifications about your subscription.": [
        "此邮箱用于接收订阅相关通知。"
      ],
      "Welcome to JiHulab Customers Portal": [
        "欢迎使用极狐订单管理中心"
      ],
      "Welcome to the GitLab Customers Portal": [
        "欢迎使用极狐订单管理中心"
      ],
      "Why can't I find my group?": [
        "为什么我不能发现我的群组？"
      ],
      "You already have at least one subscription. Do you want to manage an existing subscription or add a new subscription?": [
        "您已经至少有一个订阅。您需要管理现有订阅还是添加新订阅?"
      ],
      "You are about to remove billing account manager %{email}. If you continue, this user will no longer have access to the %{companyName} billing account.": [
        "您即将移除计费账户管理员 %{email}。如果继续，该用户将无法再访问 %{companyName} 计费账户。"
      ],
      "You are about to revoke the invitation for the billing account manager %{email}. If you continue, this user will not have access to the %{companyName} billing account.": [
        "您即将撤销发送给 %{email} 的计费账户管理员邀请。如果继续，此用户将无法访问 %{companyName} 计费账户。"
      ],
      "You are billed additionally if you exceed the number of seats entered.": [
        "如果您超过这个席位，那将额外收费"
      ],
      "You are not authorized to delete this invitation.": [
        "您无权删除此邀请。"
      ],
      "You are not authorized to delete this membership.": [
        "您无权删除此成员。"
      ],
      "You can not renew your subscription yet": [
        "当前您还不能续订"
      ],
      "You can only purchase up to 25 additional seats here. To continue with your purchase, %{linkStart}contact the sales team%{linkEnd} for assistance.": [
        "您最多只能在此处购买25个额外席位。要继续购买，%{linkStart}联系销售团队%{linkEnd}寻求帮助。"
      ],
      "You can't remove this billing account manager because they are your billing account's subscription contact. You can edit the subscription contact in the %{linkStart}Company information settings.%{linkEnd}": [
        "无法移除此计费账户管理员，因为他们是计费账户的订阅联系人。您可以在%{linkStart}公司信息设置%{linkEnd}中编辑订阅联系人。"
      ],
      "You cannot invite more managers because too many invitations are pending. Please %{supportLinkStart}contact support%{supportLinkEnd} to remove the pending invitations.": [
        "待处理的邀请过多，无法邀请更多管理员。请%{supportLinkStart}联系客服%{supportLinkEnd}移除待处理的邀请。"
      ],
      "You currently have %{quantityWithUnitLabel}.": [
        "您当前拥有 %{quantityWithUnitLabel}。"
      ],
      "You have accepted on demand billing terms. You are billed for usage beyond monthly credits. The price per credit for monthly credits is based on pricing tiers.": [
        "您已接受按需计费条款。超出月度额度的使用量将另行计费。月度额度的单额度价格基于定价阶梯。"
      ],
      "You haven't made any purchase yet": [
        "您还未购买任何东西"
      ],
      "You use GitLab.com single sign-on to sign in to your Customers Portal account. You can change GitLab.com password in your %{gitlabAccountLinkStart}GitLab.com account%{gitlabAccountLinkEnd}.": [
        "您现在使用一次性登录"
      ],
      "You will be billed for this usage at the end of the month.": [
        "此用量将在月底向您收费。"
      ],
      "You won't be billed for this usage until you accept the On-Demand billing terms.": [
        "在接受按需计费条款之前，此用量不会向您收费。"
      ],
      "You're almost there! We need a little more information from you before you can continue to the": [
        "准备就绪!在您继续访问订单系统前，我们需要您提供更多的信息"
      ],
      "You're viewing a historical statement. This data is finalized, and read-only.": [
        "您正在查看历史账单。此数据已最终确定且为只读。"
      ],
      "Your %{productName} subscription has the same term as your main subscription, and the price is prorated accordingly.": [
        "您的 %{productName} 与您的主订阅具有相同的期限，并且价格按相应比例分配。"
      ],
      "Your GitLab for %{programName} subscription (%{subscriptionIdentifier}) is up for renewal": [
        "你的 %{programName} 订阅 （%{subscriptionIdentifier}） 续订已更新"
      ],
      "Your GitLab.com Subscription Renewal": [
        "您的极狐GitLab 续订"
      ],
      "Your GitLab.com account": [
        "您的极狐GitLab 账户"
      ],
      "Your account has been updated successfully.": [
        "您的账户已成功更新。"
      ],
      "Your billing contact receives all invoices and subscription event notifications. You can select a billing account manager, or enter a custom contact.": [
        "账单联系人会收到所有发票和订阅事件通知。您可以选择一位计费账户管理员，或输入自定义联系人。"
      ],
      "Your company details": [
        "您的公司信息"
      ],
      "Your contact has been updated successfully.": [
        "您的联系人已成功更新。"
      ],
      "Your password": [
        "您的密码"
      ],
      "Your personal details": [
        "您的个人信息"
      ],
      "Your pool of GitLab Credits is active and will be used for GitLab Duo Agent Platform features going forward.": [
        "您的 GitLab Credits 池已激活，今后将用于 GitLab Duo Agent Platform 功能。"
      ],
      "Your storage subscription has the same term as your main subscription, and the price is prorated accordingly.": [
        "您的存储订阅与您的主订阅具有相同的期限，并且价格按相应比例分配。"
      ],
      "Your subscription contact is the primary contact for your billing account. They receive subscription event notifications and information about applying your subscription. You must select a billing account manager as your subscription contact.": [
        "订阅联系人是您计费账户的主要联系人，会收到订阅事件通知以及订阅应用相关信息。您必须选择一位计费账户管理员作为订阅联系人。"
      ],
      "Your subscription expired on %{endDate}.": [
        "您的订阅将在 %{endDate}过期"
      ],
      "Your subscription started on %{startDate} and will %{renewalType} on %{endDate}.": [
        "您的订阅开始时间为 %{startDate}, 将在 %{endDate} %{renewalType} "
      ],
      "Your subscription will be applied to this group": [
        "您的订阅将要应用的群组"
      ],
      "Your subscription will start on %{startDate} and %{renewalType} on %{endDate}.": [
        "您的订阅将在 %{startDate} 开始, 将在 {endDate} 更新 {renewalType} "
      ],
      "ZIP / postal code": [
        "邮政编码"
      ],
      "[GitLab Transactions]": [
        "极狐GitLab "
      ],
      "and": [
        "和"
      ],
      "and be verified by our system.": [
        "并且通过我们的系统确认"
      ],
      "application": [
        "应用"
      ],
      "auto-renew": [
        "自动续订"
      ],
      "billed annually": [
        "按年付费"
      ],
      "can't be found": [
        "无法找到"
      ],
      "compute minutes": [
        "计算分钟数"
      ],
      "contact support": [
        "联系客服"
      ],
      "credit": [
        "Credit"
      ],
      "expire": [
        "到期"
      ],
      "is not a synchronizable remote resource": [
        "不是可同步的远程资源"
      ],
      "is not a valid local resource": [
        "不是有效的本地资源"
      ],
      "is not a valid resource": [
        "不是有效的资源"
      ],
      "max credits": [
        "最大 Credit"
      ],
      "on": [
        "在"
      ],
      "per credit monthly": [
        "每 Credit/月"
      ],
      "per credit per month (billed annually)": [
        "每 Credit/月（按年付费）"
      ],
      "per seat per year": [
        "每席位/年"
      ],
      "per unit": [
        "价格"
      ],
      "per unit billed annually": [
        "按年付费"
      ],
      "per user": [
        "每人"
      ],
      "per user annually": [
        "/用户/年"
      ],
      "per user yearly": [
        "/用户/年"
      ],
      "per year": [
        "/年"
      ],
      "remove promo code successfully": [
        "移除优惠券成功"
      ],
      "required": [
        "必填"
      ],
      "seat": [
        "席位"
      ],
      "seats currently in use": [
        "席位(使用中)"
      ],
      "subscription for": [
        "订阅"
      ],
      "utilized": [
        "已使用"
      ],
      "{_field_} is required.": [
        "{_field_}不能为空"
      ]
    }
  }
};